module.exports = __webpack_public_path__ + "static/media/photo_exhibit_management.a4469c45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_exhibit_management.jpg
// module id = 388
// module chunks = 0